import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appData.desc}
            </p>
            <div className="grid grid-cols-2 gap-3">
              {appData.features.map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  {f}
                </div>
              ))}
            </div>
          </div>
          <div className="w-40 h-40 md:w-48 md:h-48 flex-shrink-0 bg-primary-500 rounded-3xl flex items-center justify-center">
            <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
          </div>
        </div>
      </div>
    </section>
  );
}